import React, { memo } from 'react';
import '@xyflow/react/dist/style.css';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { Building2 } from 'lucide-react';
export type ServiceNodeData = {
  label: string;
  type: string;
  cost: number;
  health: 'healthy' | 'warning' | 'critical';
  model: string;
  businessUnit?: string;
  vendor?: string;
  isSelected?: boolean;
  dimmed?: boolean;
};
const ServiceNode = ({
  data,
  selected
}: NodeProps<any>) => {
  const dimmed = data.dimmed === true;
  const healthColor = data.health === 'healthy' ? 'bg-[#8eff01]' : data.health === 'warning' ? 'bg-amber-500' : 'bg-red-500';
  return <div className={`
        relative px-6 py-5 rounded-lg transition-all duration-300 w-[320px]
        bg-[#1f1f1f] border shadow-lg group
        ${dimmed ? 'opacity-20 pointer-events-none' : ''}
        ${!dimmed && selected ? 'border-[#8eff01] shadow-[0_0_20px_rgba(142,255,1,0.15)]' : !dimmed ? 'border-white/[0.14] hover:border-white/[0.24]' : 'border-white/[0.08]'}
      `} data-id="element-236">
      <Handle type="source" position={Position.Bottom} className="!bg-[#8eff01] !w-3 !h-3 !border-0 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-237" />

      <div className="flex items-center gap-4" data-id="element-238">
        <div className={`w-3 h-3 rounded-full ${healthColor} ${dimmed ? 'shadow-none' : 'shadow-[0_0_10px_currentColor]'} flex-shrink-0`} data-id="element-239" />
        <div className="flex flex-col min-w-0" data-id="element-240">
          <span className="text-white text-[17px] font-medium leading-tight truncate" data-id="element-241">
            {data.label}
          </span>
          <div className="flex items-center gap-2.5 mt-1.5" data-id="element-242">
            <span className="text-white/45 text-[13px]" data-id="element-243">€{data.cost}/mo</span>
            <span className="w-1 h-1 bg-white/20 rounded-full" data-id="element-244" />
            <span className="text-white/40 text-[12px] truncate max-w-[120px]" data-id="element-245">
              {data.model}
            </span>
          </div>
        </div>
      </div>

      {/* Business Unit & Vendor row */}
      {(data.businessUnit || data.vendor) && <div className="flex items-center gap-3 mt-4 pt-3 border-t border-white/[0.10]" data-id="element-246">
          {data.businessUnit && <div className="flex items-center gap-1.5 min-w-0" data-id="element-247">
              <Building2 className="w-3.5 h-3.5 text-white/25 flex-shrink-0" data-id="element-248" />
              <span className="text-white/35 text-[11px] truncate" data-id="element-249">
                {data.businessUnit}
              </span>
            </div>}
          {data.businessUnit && data.vendor && <span className="w-1 h-1 bg-white/15 rounded-full flex-shrink-0" data-id="element-250" />}
          {data.vendor && <div className="flex items-center gap-1.5 min-w-0" data-id="element-251">
              <img src="https://cdn.magicpatterns.com/uploads/c7pvJPcwsv9qtfybE5v8RS/Logo_v1_small.svg" alt={data.vendor} className="w-4 h-4 flex-shrink-0 brightness-0 invert opacity-35" data-id="element-252" />
              <span className="text-white/35 text-[11px] truncate" data-id="element-253">
                {data.vendor}
              </span>
            </div>}
        </div>}

      <div className="absolute -top-3 -right-3 bg-[#303030] border border-white/[0.14] px-2 py-1 rounded-md text-[10px] text-white/55 uppercase tracking-wider font-medium" data-id="element-254">
        {data.type}
      </div>
    </div>;
};
export default memo(ServiceNode);